import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { images } from '../data/business';
export function MascotIntro() {
  const {
    t
  } = useLanguage();
  const stats = [{
    value: '10+',
    label: t(copy.mascotStatYears)
  }, {
    value: '500+',
    label: t(copy.mascotStatFamilies)
  }, {
    value: 'EN / ES',
    label: t(copy.mascotStatBilingual)
  }];
  return <section className="bg-white" data-id="element-247" data-mp="3tkhnc908ar6o">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-16" data-id="element-248" data-mp="2d55rsvfobq8">
        <div className="grid items-center gap-8 lg:grid-cols-[220px_1fr] lg:gap-14" data-id="element-249" data-mp="2b147hl0bot4">
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="mx-auto w-40 sm:w-52 lg:w-full" data-id="element-250" data-mp="3kl4f1jnuc8nj">
            <img src={images.mascot} alt="Cartoon mascot of a 3D Cleaning Services professional in a blue uniform holding a spray bottle and cloth" className="w-full mix-blend-multiply" data-id="element-251" data-mp="2e0lcfmoccg8p" />
          </motion.div>

          <div data-id="element-252" data-mp="3cyluxwrwtec7">
            <p className="font-display text-sm font-bold text-bright" data-id="element-253" data-mp="3cz5bpa5tpwon">{t(copy.mascotKicker)}</p>
            <h2 className="mt-2 font-display text-2xl font-extrabold tracking-tight text-navy sm:text-3xl" data-id="element-254" data-mp="37xfypoz1j8xx">
              {t(copy.mascotTitle)}
            </h2>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-charcoal/70" data-id="element-255" data-mp="3h07bbs3nkar5">
              {t(copy.mascotBody)}
            </p>

            <dl className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3" data-id="element-256" data-mp="3vnjz7ngxmskp">
              {stats.map(stat => <div key={stat.label} className="border-l-2 border-bright pl-4" data-id="element-257" data-mp="3qrbnkk1y1hia">
                  <dt className="font-display text-2xl font-extrabold text-royal" data-id="element-258" data-mp="8jvqdtci9er3">{stat.value}</dt>
                  <dd className="mt-1 text-sm text-charcoal/70" data-id="element-259" data-mp="4jvcc9tbj5kk">{stat.label}</dd>
                </div>)}
            </dl>
          </div>
        </div>
      </div>
    </section>;
}